import React, { Component } from "react";  
//import Gallery from 'react-grid-gallery';
 
import Slider from 'react-slick';
import Lightbox from 'react-image-lightbox';

class Comp7 extends Component {  
  constructor() {  
    super();  
    this.state = {  
      name: "ReactJS",
      galleryinfo: ''
    };  
  }  

   componentDidMount() {

      let info = this.props.paraminfo;
      console.log("gallery",info);
      this.setState({galleryinfo:info});
   }

  getSliderSettings(){
   return {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
   }
  }

  handleClickImage = (e, image) => {
   e && e.preventDefault();

   this.setState({
     current: image
   })
  }

  handleCloseModal = (e) => {
   e && e.preventDefault();

   this.setState({
     current: ''
   })
  }
   
  render() {  

    const settings = this.getSliderSettings();
    const { images, current } = this.state;
    console.log("galleryinfo", this.state.galleryinfo.length);

    return <div id="gallery_section"><h3>Gallery</h3>
          { this.state.galleryinfo.length==0 && 
                <div>No Gallery</div>
          }
          {this.state.galleryinfo.length>0 && 
          <Slider {...settings}>
          {
            this.state.galleryinfo && this.state.galleryinfo.map((d)=>{
               return(

                    <div className="text-center"><img src={d.src} width="200px" /></div>
                )

               })
          }
          </Slider>
          }
          </div>
  }  
}  
   
export default Comp7;